import {
  Alert,
  Box,
  Button,
  CardMedia,
  Snackbar,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { rutas } from "../../../rutas/rutas";
import { getCookie } from "../../../utils/getCookie";
import { setInformacion } from "../../../storage/slices/usuarios";

export const Crafting = () => {
  const { especiales = [], generalNft = [] } = useSelector((state) => state.userSlice);
  const { informacion } = useSelector((state) => state.userSlice);

  const [barajitas, setBarajita] = useState([]);
  const [seleccion, setSeleccion] = useState([]);
  const [open2, setOpen2] = useState(false);
  const [error, setError] = useState(false);

  // filtros
  const [filtroRareza, setFiltroRareza] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [orden, setOrden] = useState("cantidad_desc");
  const [soloDisponibles, setSoloDisponibles] = useState(true);

  const dispatch = useDispatch();

  const rarezas = {
    C: 5,
    R: 4,
    E: 3,
    L: 2,
  };

  const rarezaPeso = {
    L: 4,
    E: 3,
    R: 2,
    C: 1,
  };

  const handleClose2 = () => setOpen2(false);

  const addBarajita = (card) => {
    const longitud = seleccion.filter((cartas) => cartas?.id === card?.id).length;
    const longitudRareza = seleccion.filter(
      (cartas) => cartas?.rareza === card?.rareza
    ).length;

    if (seleccion?.length > 0) {
      if (
        card?.id?.[0] === seleccion[0]?.id?.[0] &&
        card?.rareza === seleccion[0]?.rareza &&
        rarezas[seleccion[0]?.rareza] > longitudRareza &&
        longitud < card?.cantidad
      ) {
        setSeleccion([...seleccion, { ...card, ideFront: uuidv4() }]);
      }
    } else {
      if (longitud < card?.cantidad) {
        setSeleccion([...seleccion, { ...card, ideFront: uuidv4() }]);
      }
    }
  };

  const ejecutarCrafting = () => {
    if (!seleccion?.length) return;

    const longitudRareza = seleccion.filter(
      (cartas) => cartas?.rareza === seleccion[0]?.rareza
    ).length;

    if (rarezas[seleccion[0]?.rareza] === longitudRareza) {
      const tokenJWT = getCookie("token");
      const ruta = rutas.crafting;

      axios
        .post(ruta, { cartas: seleccion }, { headers: { token: tokenJWT } })
        .then((res) => {
          setError(false);
          setOpen2(true);
          setSeleccion([]);
          dispatch(setInformacion({ ...res.data?.resultado }));
        })
        .catch((err) => {
          setError(true);
          setOpen2(true);
          console.error(err);
        });
    }
  };

  const deleteBarajita = (card) => {
    setSeleccion((state) => state.filter((carta) => carta?.ideFront !== card?.ideFront));
  };

  useEffect(() => {
    let total = [];

    if (informacion?.especial?.length > 0) {
      total = [
        ...total,
        ...informacion.especial.map((i) => ({
          ...i,
          origen: "especial",
          tipo: i?.id?.[0] === "E" ? "E" : "G",
          url: [...especiales, ...generalNft].find((t) => t.ide === i.ide)?.url,
        })),
      ];
    }

    if (informacion?.general?.length > 0) {
      total = [
        ...total,
        ...informacion.general.map((i) => ({
          ...i,
          origen: "general",
          tipo: i?.id?.[0] === "E" ? "E" : "G",
          url: [...especiales, ...generalNft].find((t) => t.ide === i.ide)?.url,
        })),
      ];
    }

    setBarajita(total);
  }, [informacion, especiales, generalNft]);

  const barajitasFiltradas = useMemo(() => {
    let resultado = [...barajitas];

    if (filtroRareza) {
      resultado = resultado.filter((card) => card?.rareza === filtroRareza);
    }

    if (filtroTipo) {
      resultado = resultado.filter((card) => card?.tipo === filtroTipo);
    }

    if (soloDisponibles) {
      resultado = resultado.filter((card) => Number(card?.cantidad) > 0);
    }

    if (busqueda.trim()) {
      const texto = busqueda.toLowerCase().trim();
      resultado = resultado.filter(
        (card) =>
          String(card?.id || "").toLowerCase().includes(texto) ||
          String(card?.ide || "").toLowerCase().includes(texto) ||
          String(card?.nombre || "").toLowerCase().includes(texto)
      );
    }

    resultado.sort((a, b) => {
      switch (orden) {
        case "cantidad_asc":
          return (a?.cantidad || 0) - (b?.cantidad || 0);

        case "cantidad_desc":
          return (b?.cantidad || 0) - (a?.cantidad || 0);

        case "rareza_desc":
          return (rarezaPeso[b?.rareza] || 0) - (rarezaPeso[a?.rareza] || 0);

        case "rareza_asc":
          return (rarezaPeso[a?.rareza] || 0) - (rarezaPeso[b?.rareza] || 0);

        case "tipo_asc":
          return String(a?.tipo || "").localeCompare(String(b?.tipo || ""));

        case "id_asc":
          return String(a?.id || "").localeCompare(String(b?.id || ""));

        default:
          return 0;
      }
    });

    return resultado;
  }, [barajitas, filtroRareza, filtroTipo, busqueda, orden, soloDisponibles]);

  return (
    <>
      <Box sx={{ height: "100%", width: "100%", display: "flex" }}>
        <Box
          sx={{
            height: "100%",
            width: "30%",
            background: "rgba(0,0,0,0.3)",
            marginRight: 1,
          }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Typography
              sx={{
                color: "white",
                fontSize: "1.3rem",
                textAlign: "center",
                textShadow: "2px 2px 3px gold",
                mb: 1,
              }}
            >
              You need{" "}
              {rarezas[seleccion[0]?.rareza] ? rarezas[seleccion[0]?.rareza] : 0}{" "}
              {seleccion[0]?.rareza} Cards
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                height: "80%",
                justifyContent: "center",
              }}
            >
              {seleccion.map((card) => (
                <Box sx={{ position: "relative", width: "95px" }} key={card.ideFront}>
                  <Box sx={{ position: "absolute", color: "white" }}>
                    {card?.id?.[0] === "E" ? "E" : "G"} - {card?.cantidad}
                  </Box>

                  <CardMedia
                    onClick={() => deleteBarajita(card)}
                    sx={{ width: "85px", cursor: "pointer" }}
                    component="img"
                    image={card?.url}
                    alt="card"
                  />
                </Box>
              ))}
            </Box>

            <Button
              onClick={ejecutarCrafting}
              fullWidth
              color="error"
              variant="contained"
            >
              Crafting
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            background: "rgba(0,0,0,0.3)",
            height: "100%",
            width: "80%",
            display: "flex",
            flexDirection: "column",
            p: 1,
            gap: 1,
          }}
        >
          {/* FILTROS */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              alignItems: "center",
              background: "rgba(255,255,255,0.05)",
              p: 1,
              borderRadius: 1,
            }}
          >
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel sx={{ color: "white" }}>Rareza</InputLabel>
              <Select
                value={filtroRareza}
                label="Rareza"
                onChange={(e) => setFiltroRareza(e.target.value)}
                sx={{ color: "white" }}
              >
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="C">C</MenuItem>
                <MenuItem value="R">R</MenuItem>
                <MenuItem value="E">E</MenuItem>
                <MenuItem value="L">L</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel sx={{ color: "white" }}>Tipo</InputLabel>
              <Select
                value={filtroTipo}
                label="Tipo"
                onChange={(e) => setFiltroTipo(e.target.value)}
                sx={{ color: "white" }}
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="E">E</MenuItem>
                <MenuItem value="G">G</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel sx={{ color: "white" }}>Ordenar</InputLabel>
              <Select
                value={orden}
                label="Ordenar"
                onChange={(e) => setOrden(e.target.value)}
                sx={{ color: "white" }}
              >
                <MenuItem value="cantidad_desc">Cantidad ↓</MenuItem>
                <MenuItem value="cantidad_asc">Cantidad ↑</MenuItem>
                <MenuItem value="rareza_desc">Rareza ↓</MenuItem>
                <MenuItem value="rareza_asc">Rareza ↑</MenuItem>
                <MenuItem value="tipo_asc">Tipo</MenuItem>
                <MenuItem value="id_asc">ID</MenuItem>
              </Select>
            </FormControl>

            <TextField
              size="small"
              label="Buscar"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              placeholder="id, ide o nombre"
              sx={{
                minWidth: 220,
                input: { color: "white" },
                label: { color: "white" },
              }}
            />

            <Button
              variant={soloDisponibles ? "contained" : "outlined"}
              onClick={() => setSoloDisponibles(!soloDisponibles)}
            >
              {soloDisponibles ? "Solo disponibles" : "Mostrar todas"}
            </Button>

            <Button
              color="warning"
              variant="outlined"
              onClick={() => {
                setFiltroRareza("");
                setFiltroTipo("");
                setBusqueda("");
                setOrden("cantidad_desc");
                setSoloDisponibles(true);
              }}
            >
              Limpiar filtros
            </Button>
          </Box>

          {/* LISTADO */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexWrap: "wrap",
              overflow: "auto",
              gap: 1,
              alignContent: "flex-start",
            }}
          >
            {barajitasFiltradas.map((card) => (
              <Box sx={{ position: "relative", width: "125px" }} key={`${card.ide}-${card.id}`}>
                <Box sx={{ position: "absolute", color: "white", zIndex: 1 }}>
                  {card?.tipo} - {card?.cantidad}
                </Box>

                <CardMedia
                  onClick={() => addBarajita(card)}
                  sx={{
                    width: "125px",
                    cursor: "pointer",
                    opacity: Number(card?.cantidad) > 0 ? 1 : 0.45,
                    border:
                      filtroRareza && card?.rareza === filtroRareza
                        ? "2px solid gold"
                        : "2px solid transparent",
                    borderRadius: 1,
                  }}
                  component="img"
                  image={card?.url}
                  alt="card"
                />

                <Typography
                  sx={{
                    color: "white",
                    fontSize: "0.8rem",
                    textAlign: "center",
                    mt: 0.5,
                  }}
                >
                  {card?.rareza} | {card?.id}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
          {error ? (
            <Alert
              onClose={handleClose2}
              severity="error"
              variant="filled"
              sx={{ width: "100%" }}
            >
              Insufficient Balance Error
            </Alert>
          ) : (
            <Alert
              onClose={handleClose2}
              severity="success"
              variant="filled"
              sx={{ width: "100%" }}
            >
              Success
            </Alert>
          )}
        </Snackbar>
      </Stack>
    </>
  );
};